module.exports = __webpack_public_path__ + "static/media/blog.18b39575.svg";